<div class="search-section">
  <div class="search-row">
    <label class="search-label" for="requestIdInput">Request ID:</label>
    <input
      id="requestIdInput"
      type="text"
      class="search-input"
      placeholder="Enter Request ID"
      [(ngModel)]="requestIdInput"
      (keydown.enter)="onDiagnose()" />
    <ukg-button
      emphasis="high"
      size="medium"
      [disabled]="!requestIdInput.trim()"
      (click)="onDiagnose()"
      (keydown.enter)="onDiagnose()"
      >Diagnose</ukg-button
    >
  </div>
</div>

<!-- Legend -->
<div class="legend-bar">
  <strong>Legend:</strong>
  <span class="legend-item"><span class="dot dot-green"></span> OK</span>
  <span class="legend-item"><span class="dot dot-red"></span> MISMATCH</span>
  <span class="legend-item"><span class="dot dot-yellow"></span> ERROR</span>
  <span class="legend-item"><span class="dot dot-blue"></span> INFO</span>
  <span class="legend-item"><span class="dot dot-grey"></span> N/A</span>
</div>

<!-- Results -->
@if (requestDiagnosticConfig.showSection) {
  <div class="diagnostic-results">
    <!-- Request Summary -->
    <div class="result-card">
      <div class="result-card-header">
        <h3>Request Summary</h3>
        @if (diagnosticError) {
          <div>{{ diagnosticError }}</div>
        }
        <div class="remediation-actions">
          @if (diagnosticResult) {
            @if (!diagnosticResult.request.isVisible) {
              <ukg-button
                emphasis="medium"
                size="small"
                (click)="onFixVisibility()"
                (keydown.enter)="onFixVisibility()"
                >Fix Visibility</ukg-button
              >
            }
            @if (diagnosticResult.request.isProcessing) {
              <ukg-button
                emphasis="medium"
                size="small"
                (click)="onReleaseProcessingLock()"
                (keydown.enter)="onReleaseProcessingLock()"
                >Release Lock</ukg-button
              >
            }
          }
          <button
            class="card-refresh-btn"
            (click)="refreshRequestSummary()"
            title="Refresh">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
              stroke-linecap="round"
              stroke-linejoin="round">
              <polyline points="23 4 23 10 17 10"></polyline>
              <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
            </svg>
          </button>
        </div>
      </div>
      @if (requestDiagnosticConfig.isLoading) {
        <div class="spinner">
          @if (requestDiagnosticConfig.isLoading) {
            <ukg-progress-circular
              size="small"
              indeterminate="true"
              description="Loading diagnostics..." />
          }
        </div>
      } @else {
        @if (diagnosticResult && diagnosticResult.request) {
          <div class="summary-grid">
            <div class="summary-item">
              <span class="lbl">Request ID: </span
              ><span class="val">{{ diagnosticResult.request.requestId }}</span>
            </div>
            <div class="summary-item">
              <span class="lbl">AR Number: </span
              ><span class="val">{{ diagnosticResult.request.arNumber }}</span>
            </div>
            <div class="summary-item">
              <span class="lbl">Company: </span
              ><span class="val">{{
                diagnosticResult.request.companyName ?? '—'
              }}</span>
            </div>
            <div class="summary-item">
              <span class="lbl">Status: </span
              ><span class="val">{{
                diagnosticResult.request.requestStatus ?? '—'
              }}</span>
            </div>
            <div class="summary-item">
              <span class="lbl">Created: </span
              ><span class="val">{{
                diagnosticResult.request.createdDate | date: 'MM/dd/yyyy h:mm a'
              }}</span>
            </div>
            <div class="summary-item">
              <span class="lbl">Created By: </span
              ><span class="val">{{
                diagnosticResult.request.createdBy ?? '—'
              }}</span>
            </div>
            <div class="summary-item">
              <span class="lbl">Assigned To: </span
              ><span class="val">{{
                diagnosticResult.request.assignedTo ?? '—'
              }}</span>
            </div>
            <div class="summary-item">
              <span class="lbl">Print Site: </span
              ><span class="val">{{
                diagnosticResult.request.printSite ?? '—'
              }}</span>
            </div>
            <div class="summary-item">
              <span class="lbl">Country: </span
              ><span class="val">{{
                diagnosticResult.request.countryCode ?? '—'
              }}</span>
            </div>
            <div class="summary-item">
              <span class="lbl">SLA: </span
              ><span class="val">{{
                diagnosticResult.request.sla === '1'
                  ? 'Yes'
                  : diagnosticResult.request.sla === '0'
                    ? 'No'
                    : (diagnosticResult.request.sla ?? '—')
              }}</span>
            </div>
            <div class="summary-item">
              <span class="lbl">Manual Check: </span
              ><span class="val">{{
                diagnosticResult.request.isManualCheck ? 'Yes' : 'No'
              }}</span>
            </div>
            <div class="summary-item">
              <span class="lbl">Is GarnCorp: </span
              ><span class="val">{{
                diagnosticResult.request.isGarnCorp ? 'Yes' : 'No'
              }}</span>
            </div>
            <div class="summary-item">
              <span class="lbl">Is Visible On Grid: </span
              ><span
                class="val"
                [class.flag-good]="diagnosticResult.request.isVisible"
                [class.flag-bad]="!diagnosticResult.request.isVisible"
                >{{ diagnosticResult.request.isVisible ? 'Yes' : 'No' }}</span
              >
            </div>
            <div class="summary-item">
              <span class="lbl">Is Processing: </span
              ><span
                class="val"
                [class.flag-warn]="diagnosticResult.request.isProcessing"
                >{{
                  diagnosticResult.request.isProcessing ? 'Yes' : 'No'
                }}</span
              >
            </div>
          </div>
        }
      }
      @if (fileDiagnosticResult && fileDiagnosticResult.files) {
        <div class="summary-overall">
          <strong>Overall:</strong>
          <span
            >{{ fileDiagnosticResult.files.length }}
            {{
              fileDiagnosticResult.files.length === 1 ? 'file' : 'files'
            }}</span
          >
          @if (getMismatchCount() > 0) {
            <span class="result-badge badge-mismatch">
              <span class="dot dot-red"></span>
              {{ getMismatchCount() }} MISMATCH
            </span>
          }
        </div>
      }
    </div>
    <!-- File Verification -->
    @if (fileDiagnosticConfig.showSection) {
      <div class="result-card">
        <div class="result-card-header">
          <h3>File Verification</h3>
          <button
            class="card-refresh-btn"
            (click)="refreshFileVerification()"
            title="Refresh">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
              stroke-linecap="round"
              stroke-linejoin="round">
              <polyline points="23 4 23 10 17 10"></polyline>
              <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
            </svg>
          </button>
        </div>
        @if (fileDiagnosticError) {
          <div>{{ fileDiagnosticError }}</div>
        }
        @if (fileDiagnosticConfig.isLoading) {
          <div class="spinner">
            @if (dataParityDiagnosticConfig.isLoading) {
              <ukg-progress-circular
                size="small"
                indeterminate="true"
                description="Loading diagnostics..." />
            }
          </div>
        } @else {
          @if (fileDiagnosticResult) {
            <app-diagnostic-file-verification
              [files]="fileDiagnosticResult.files" />
          }
        }
      </div>
    }
    <!-- Ingestion Trail -->
    @if (ingestionDiagnosticConfig.showSection) {
      <div class="result-card">
        <div class="result-card-header">
          <h3>Ingestion Trail</h3>
          <button
            class="card-refresh-btn"
            (click)="refreshIngestionTrail()"
            title="Refresh">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
              stroke-linecap="round"
              stroke-linejoin="round">
              <polyline points="23 4 23 10 17 10"></polyline>
              <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
            </svg>
          </button>
        </div>
        @if (ingestionTrailError) {
          <div>{{ ingestionTrailError }}</div>
        }
        @if (ingestionDiagnosticConfig.isLoading) {
          <div class="spinner">
            @if (ingestionDiagnosticConfig.isLoading) {
              <ukg-progress-circular
                size="small"
                indeterminate="true"
                description="Loading diagnostics..." />
            }
          </div>
        } @else {
          @if (ingestionTrailResult && ingestionTrailResult.ingestionTrail) {
            <div>
              @if (ingestionTrailResult.ingestionTrail.length === 0) {
                <p class="empty-state">
                  No ingestion trail records found for this request.
                </p>
              }
              @if (!!ingestionTrailResult.ingestionTrail.length) {
                <div class="table-wrapper">
                  <table class="data-table">
                    <thead>
                      <tr>
                        <th>Source</th>
                        <th>Process ID</th>
                        <th>AR Number</th>
                        <th>File Name</th>
                        <th>Status</th>
                        <th>Created</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (
                        trail of ingestionTrailResult.ingestionTrail;
                        track trail
                      ) {
                        <tr>
                          <td>
                            <span class="source-badge">{{ trail.source }}</span>
                          </td>
                          <td class="mono">{{ trail.processId ?? '—' }}</td>
                          <td>{{ trail.arNumber ?? '—' }}</td>
                          <td class="file-name">{{ trail.fileName ?? '—' }}</td>
                          <td>{{ trail.processStatus ?? '—' }}</td>
                          <td>
                            {{ trail.createdDate | date: 'MM/dd/yyyy h:mm a' }}
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
            </div>
          }
        }
      </div>
    }
    <!-- Data Parity -->
    @if (dataParityDiagnosticConfig.showSection) {
      <div class="result-card">
        <div class="result-card-header">
          <h3>CheckPrint / CheckLog Data Parity</h3>
          <button
            class="card-refresh-btn"
            (click)="refreshDataParity()"
            title="Refresh">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
              stroke-linecap="round"
              stroke-linejoin="round">
              <polyline points="23 4 23 10 17 10"></polyline>
              <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
            </svg>
          </button>
        </div>
        @if (dataParityDiagnosticError) {
          <div>{{ dataParityDiagnosticError }}</div>
        }
        @if (dataParityDiagnosticConfig.isLoading) {
          <div class="spinner">
            @if (dataParityDiagnosticConfig.isLoading) {
              <ukg-progress-circular
                size="small"
                indeterminate="true"
                description="Loading diagnostics..." />
            }
          </div>
        } @else {
          @if (dataParityResult && dataParityResult.dataParity) {
            <div>
              @if (dataParityResult.dataParity.isError) {
                <div class="error-banner">
                  {{ dataParityResult.dataParity.errorMessage }}
                </div>
              }
              @if (!dataParityResult.dataParity.isError) {
                <div class="table-wrapper">
                  <table class="data-table">
                    <thead>
                      <tr>
                        <th>Field</th>
                        <th>CheckPrint</th>
                        <th>CheckLog</th>
                        <th>Match</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (
                        row of dataParityResult.dataParity.rows;
                        track row
                      ) {
                        <tr
                          [class.row-mismatch]="
                            !row.isMatch && row.checkLogValue !== null
                          ">
                          <td class="field-label">{{ row.field }}</td>
                          <td>{{ row.checkPrintValue ?? '—' }}</td>
                          <td>{{ row.checkLogValue ?? '—' }}</td>
                          <td>
                            @if (row.checkLogValue !== null) {
                              <span
                                class="result-badge"
                                [class]="
                                  row.isMatch ? 'badge-ok' : 'badge-mismatch'
                                ">
                                <span
                                  class="dot"
                                  [class]="
                                    row.isMatch ? 'dot-green' : 'dot-red'
                                  "></span>
                                {{ row.isMatch ? 'Match' : 'Mismatch' }}
                              </span>
                            } @else {
                              <span class="result-badge badge-na">
                                <span class="dot dot-grey"></span>
                                N/A
                              </span>
                            }
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
            </div>
          }
        }
      </div>
    }
    <!-- Email & Callback -->
    @if (emailCallbackDiagnosticConfig.showSection) {
      <div class="result-card">
        <div class="result-card-header">
          <h3>Email &amp; Callback Status</h3>
          <button
            class="card-refresh-btn"
            (click)="refreshEmailCallback()"
            title="Refresh">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
              stroke-linecap="round"
              stroke-linejoin="round">
              <polyline points="23 4 23 10 17 10"></polyline>
              <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
            </svg>
          </button>
        </div>
        @if (emailCallbackError) {
          <div>{{ emailCallbackError }}</div>
        }
        @if (emailCallbackDiagnosticConfig.isLoading) {
          <div class="spinner">
            @if (emailCallbackDiagnosticConfig.isLoading) {
              <ukg-progress-circular
                size="small"
                indeterminate="true"
                description="Loading diagnostics..." />
            }
          </div>
        } @else {
          @if (emailCallbackResult && emailCallbackResult.emailCallbackStatus) {
            <div class="table-wrapper">
              <table class="data-table">
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Status</th>
                    <th>Timestamp</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="field-label">Confirmation Email</td>
                    <td>
                      <span
                        class="result-badge"
                        [class]="
                          emailCallbackResult.emailCallbackStatus
                            .confirmationEmailSent
                            ? 'badge-ok'
                            : 'badge-na'
                        ">
                        {{
                          emailCallbackResult.emailCallbackStatus
                            .confirmationEmailSent
                            ? 'Sent'
                            : 'Not sent'
                        }}
                      </span>
                    </td>
                    <td>
                      {{
                        emailCallbackResult.emailCallbackStatus
                          .confirmationEmailTimestamp ?? '—'
                      }}
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td class="field-label">NetPay Callback</td>
                    <td>
                      <span
                        class="result-badge"
                        [class]="
                          emailCallbackResult.emailCallbackStatus
                            .netPayCallbackStatus
                            ? 'badge-ok'
                            : 'badge-na'
                        ">
                        {{
                          emailCallbackResult.emailCallbackStatus
                            .netPayCallbackStatus ?? 'No callback recorded'
                        }}
                      </span>
                    </td>
                    <td>
                      {{
                        emailCallbackResult.emailCallbackStatus
                          .netPayCallbackTimestamp ?? '—'
                      }}
                    </td>
                    <td></td>
                  </tr>
                  <tr
                    [class.row-warn]="
                      emailCallbackResult.emailCallbackStatus
                        .hasAcknowledgementFailures
                    ">
                    <td class="field-label">NetPay Ack Failures</td>
                    <td>
                      <span
                        class="result-badge"
                        [class]="
                          emailCallbackResult.emailCallbackStatus
                            .hasAcknowledgementFailures
                            ? 'badge-error'
                            : 'badge-ok'
                        ">
                        {{
                          emailCallbackResult.emailCallbackStatus
                            .acknowledgementFailureCount
                        }}
                        failure(s)
                      </span>
                    </td>
                    <td>—</td>
                    <td>
                      <button
                        class="action-btn"
                        (click)="onRetryNetPayCallback()"
                        [disabled]="
                          !emailCallbackResult.emailCallbackStatus
                            .hasAcknowledgementFailures
                        ">
                        Retry NetPay Callback
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          }
        }
      </div>
    }
  </div>
}

<app-confirm-dialog />
